module.exports = __webpack_public_path__ + "static/media/accidentInsuranceLandingPage.d90dc232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/accidentInsuranceLandingPage.png
// module id = 672
// module chunks = 21